import React from "react";
import "./button.scss";
import { Link } from "react-router-dom";

const SecondaryButton = ({ text, type, onClick, disabled, to, glow = false }) => {
  return (
    <div>
      <Link to={to}>
        <button
          type={type}
          className={!glow ? "secondaryBtn" : "secondaryBtn glow-button"}
          onClick={onClick}
          disabled={disabled}
          style={{ opacity: disabled ? "0.5" : "1" }}
        >
          {text}
        </button>
      </Link>
    </div>
  );
};

export default SecondaryButton;
